import { ActionTypes } from 'utils/constants';
import { getDeepProp } from 'utils/get-deep-prop';

const initialState = {};

export const myProgressPosts = (state = initialState, action) => {
    switch(action.type) {
        case ActionTypes.FETCH_PROGRESS_POSTS + '_PENDING': {            
            return {
                ...state,
                fetching: true
            };
        }
        case ActionTypes.FETCH_PROGRESS_POSTS + '_FULFILLED': {  
            const posts = getDeepProp(action, 'payload', 'data', 'progress_posts') || {};
          
            return {
                ...state,
                posts,
                fetched: true
            };
        }
        case ActionTypes.FETCH_PROGRESS_POSTS + '_REJECTED': {    
            const error = getDeepProp(action, 'payload', 'response', 'data', 'msg');
        
            return {
                ...state,
                fetching: false,
                fetched: false,
                error
            };
        }
        case ActionTypes.LOGOUT:
        case ActionTypes.VALIDATE_JWT + '_REJECTED': {
            return initialState;
        }
        default: {
            return state;
        }
    }
};
